import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'


const MusicLazy = createLazyComponent(() => import('./Music'))

const Music = (props) => <MusicLazy {...props} />

export default Music
